module.exports = __webpack_public_path__ + "img/labmemtest_text_btn01_en.0329f52c.png";